import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

// Files Import
import { content } from "../../../data";
import NftCartHub from "../../Modals/NftCartHub/NftCartHub";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import { CustomConnectButton } from "../../CustomConnectButton/CustomConnectButton";
import StyledH3Heading from "../../../common/components/styledH3Heading/StyledH3Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import useNetwork from "../../../Hooks/useNetwork";
import IconifyIcon from "../../icons/Icon";

const MobileHeader = ({cartData}) => {
  const location = useLocation();
  const [navShow, setNavShow] = useState(false);
  const [showNftCartHub, setShowNftCartHub] = useState(false);
  const { isConnected, validChain } = useNetwork(); 

  const toggleNav = () => {
    setNavShow(!navShow);
    document.body.style.overflowY = navShow ? "auto" : "hidden";
  };

  const handleIconClick = () => {
    setShowNftCartHub(true);
  };



  return (
    <div className="flex gap-2 lg:hidden z-50">
      {/* Conditional User Profile: Show only when wallet is connected */}
      {isConnected && validChain && (
        <Link
          to={"/profile"}
          className="group hover:bg-white hover:bg-opacity-10 border border-bright-yellow py-2 px-2.5 rounded-md"
        >
          <IconifyIcon
            className="text-white group-hover:hidden"
            height={20}
            width={20}
            icon="fa-regular:user"
            color="white"
          />

          <IconifyIcon
            className="text-white group-hover:text-[#FFDE04] hidden group-hover:block"
            height={20}
            width={20}
            icon="fa-solid:user"
            color="#FFDE04"
          />
        </Link>
      )}

      {/* User Cart */}
    {isConnected && validChain &&  <div
        className="relative group cursor-pointer flex justify-center items-center h-fit p-2 hover:bg-white hover:bg-opacity-10 border border-bright-yellow rounded-md"
        onClick={handleIconClick}
      >
        <IconifyIcon
          className="text-white group-hover:hidden"
          height={24}
          width={24}
          icon="mingcute:shopping-bag-2-line"
          color="white"
        />

        <IconifyIcon
          className="text-white group-hover:text-[#FFDE04] hidden group-hover:block"
          w
          height={24}
          width={24}
          icon="mingcute:shopping-bag-2-fill"
          color="#FFDE04"
        />
        {cartData?.length > 0 && (
          <StyledSmText fontColor="absolute -top-2 -right-2 !font-semibold w-5 h-5 text-black bg-bright-yellow rounded-full flex justify-center items-center">
            {cartData.length}
          </StyledSmText>
        )}
      </div>}

      {/* Hamburger Button */}
      <button
        type="button"
        className="flex items-center justify-center h-fit p-2 border border-bright-yellow rounded-md"
        aria-label="Toggle Menu"
        onClick={toggleNav}
      >
        <IconifyIcon
          className="text-white group-hover:hidden"
          height={24}
          width={24}
          icon="ion:menu"
          color="white"
        />

        <IconifyIcon
          className="text-white group-hover:text-[#FFDE04] hidden group-hover:block"
          w
          height={24}
          width={24}
          icon="ion:menu"
          color="#FFDE04"
        />
      </button>

      <div
        className={`bg-black w-screen h-screen z-50 fixed inset-0 top-0 left-0 flex flex-col justify-between py-4 ${
          navShow ? "translate-x-[0%]" : "-translate-x-[110%]"
        }`}
        style={{ transition: "all 0.5s cubic-bezier(.68,-0.55,.27,1.55)" }}
      >
        {/* Header */}
        <div className="flex items-center justify-center w-[90%] mx-auto">
          <Link to="/" className="flex justify-center">
            <img
              className="w-[80%]"
              src="/assets/mobile-header-logo.svg"
              alt="Logo"
              onClick={toggleNav}
            />
          </Link>

          <button
            type="button"
            className="z-10 w-fit absolute right-4 flex items-center justify-center h-fit p-1 border border-bright-yellow rounded-md"
            aria-label="Toggle Menu"
            onClick={toggleNav}
          >
            <IconifyIcon
              className="text-white group-hover:hidden"
              height={30}
              width={30}
              icon="charm:cross"
              color="white"
            />

            <IconifyIcon
              className="text-white group-hover:text-[#FFDE04] hidden group-hover:block"
              w
              height={30}
              width={30}
              icon="charm:cross"
              color="#FFDE04"
            />
          </button>
        </div>

        {/* NavLinks */}
        <nav className="flex flex-col justify-center items-center gap-4 w-full">
          {content.header.map((item, index) => (
            <NavLink
              key={index}
              to={item.link}
              onClick={toggleNav}
              className={`${
                location.pathname === item.link
                  ? "text-bright-yellow"
                  : "text-white"
              } hover:scale-x-110 hover:text-bright-yellow transform transition`}
            >
              <StyledH3Heading>{item.title}</StyledH3Heading>
            </NavLink>
          ))}
        </nav>

        {/* Links */}
        <footer className="w-full flex flex-col gap-8">
          <div className="w-full flex justify-center">
            <CustomConnectButton />
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-2">
            {content.Footer.filter(
              (item, index) => index === 3 || index === 4
            ).map((item, index) => (
              <NavLink
                key={index}
                to={item.link}
                onClick={toggleNav}
                className="text-white hover:scale-x-105 transform transition"
              >
                <StyledH6Heading>{item.title}</StyledH6Heading>
              </NavLink>
            ))}
          </div>

          {/* Social Icons */}
          <div className="w-full flex justify-center gap-6 xl:gap-8 items-center">
            {content.socialIcons.map((items, index) => (
              <Link
                className="group hover:-translate-y-[3px] duration-200"
                key={index}
                to={items.link}
                target="_blank"
                onClick={toggleNav}
              >
                <span className="text-white">{items.icon}</span>
              </Link>
            ))}
          </div>
        </footer>
      </div>
      {showNftCartHub && (
        <NftCartHub closeModal={() => setShowNftCartHub(false)} />
      )}
    </div>
  );
};

export default MobileHeader;
